/* Estilos comuns das interfaces */
export const uiStyles = {
    iconGroup: {
        display: 'inline-flex',
        gap: 5
    },
    actionIcon: {
        fontSize: 24,
        color: '#3f51b5',
        cursor: 'pointer'
    },
    disabledActionIcon: {
        color: '#bdbdbd',
        cursor: 'default'
    },
    formActions: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10
    }
};

/* Altera a cor padrão do ícone ao passar o cursor */
export const handleIconMouseEnter = (event) => {
    event.currentTarget.style.color = '#2979ff';
};

/* Retorna o ícone à cor padrão */
export const handleIconMouseLeave = (event) => {
    event.currentTarget.style.color = '#3f51b5';
};

/* Altera a cor do ícone de exclusão */
export const handleDeleteIconMouseEnter = (event) => {
    event.currentTarget.style.color = 'red';
};

/* Retorna o ícone de exclusão à cor padrão */
export const handleDeleteIconMouseLeave = (event) => {
    event.currentTarget.style.color = 'red';
};

/* Executa o hover somente quando o ícone estiver habilitado */
export const handleEnabledIconMouseEnter = (
    event,
    disabled,
    handler = handleIconMouseEnter
) => {
    if (!disabled && typeof handler === 'function') {
        handler(event);
    }
};

/* Executa a saída do hover somente quando o ícone estiver habilitado */
export const handleEnabledIconMouseLeave = (
    event,
    disabled,
    handler = handleIconMouseLeave
) => {
    if (!disabled && typeof handler === 'function') {
        handler(event);
    }
};